module.exports = __webpack_public_path__ + "img/back-button-glt.afee55b9.png";